import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {Skeleton} from 'primereact/skeleton'
import {TabPanel, TabView} from 'primereact/tabview'
import {forwardRef, useImperativeHandle, useMemo} from 'react'
import downloadImg from '../../assets/images/undraw_download.svg'
import {SystemRole} from '../../Constants'
import {useAppConfig} from '../../context/app/AppContext'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import {getSuperAdminRole} from '../authentication/AuthUtils'
import UserGuide from '../tutorial/TaVIE-User-Guide-v.1.1.pdf'
const Tutorial = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: () => showForm(),
    }))

    const {userRole} = useAppConfig()
    const {translateCommons} = TranslateUtils()

    const visibleFullScreen = useSignal(false)

    const languageVideo = useSignal(null)
    const showForm = () => {
        languageVideo.value = getLanguageCode()
        visibleFullScreen.value = true
        blockOverflownScroll()
    }
    const hideForm = () => {
        visibleFullScreen.value = false
        unblockOverflownScroll()
    }

    const videoDataList = useMemo(() => {
        let holderListVideo = []
        if (userRole === SystemRole.ADMIN || getSuperAdminRole()) {
            holderListVideo.push({
                key: 'TaVIE Overview and Tutorial',
                video: 'https://www.youtube.com/embed/tipaOK6CP9A',
            })
            if (languageVideo.value === 'bg') {
                holderListVideo.push(
                    {
                        key: 'TaVIE Web Console Training for Super User (in Bulgarian)',
                        video: 'https://www.youtube.com/embed/S7XyuzE2TEw',
                    },
                    {
                        key: 'TaVIE Web Console Training (in Bulgarian)',
                        video: 'https://www.youtube.com/embed/fzkwDFTkSYc',
                    },
                )
            } else {
                holderListVideo.push(
                    {
                        key: 'TaVIE Web Console Training for Super User (in English)',
                        video: 'https://www.youtube.com/embed/ztHKPkaAIcI',
                    },
                    {
                        key: 'TaVIE Web Console Training (in English)',
                        video: 'https://www.youtube.com/embed/5YO7qgNcwhc',
                    },
                )
            }
        } else if (userRole === SystemRole.USER_WITH_ROLE) {
            holderListVideo.push({
                key: 'TaVIE Overview and Tutorial',
                video: 'https://www.youtube.com/embed/tipaOK6CP9A',
            })
            if (languageVideo.value === 'bg') {
                holderListVideo.push({
                    key: 'TaVIE Web Console Training (in Bulgarian)',
                    video: 'https://www.youtube.com/embed/fzkwDFTkSYc',
                })
            } else {
                holderListVideo.push({
                    key: 'TaVIE Web Console Training (in English)',
                    video: 'https://www.youtube.com/embed/5YO7qgNcwhc',
                })
            }
        } else if (userRole === SystemRole.USER) {
            holderListVideo.push({
                key: 'TaVIE Overview and Tutorial',
                video: 'https://www.youtube.com/embed/v2SWx-TZT5Y',
            })
            if (languageVideo.value === 'bg') {
                holderListVideo.push({
                    key: 'TaVIE Web Console Training (in Bulgarian)',
                    video: 'https://www.youtube.com/embed/fzkwDFTkSYc',
                })
            } else {
                holderListVideo.push({
                    key: 'TaVIE Web Console Training (in English)',
                    video: 'https://www.youtube.com/embed/5YO7qgNcwhc',
                })
            }
        }

        return holderListVideo
    }, [languageVideo.value, userRole])

    return (
        <div className="col-12">
            <Dialog
                className="p-sidebar-full p-0"
                header={translateCommons('Tutorials')}
                pt={{content: {className: 'p-0'}}}
                visible={visibleFullScreen.value}
                onHide={() => hideForm()}
                breakpoints={{'1000px': '70vw', '780px': '100vw'}}>
                <div className="w-full">
                    <TabView>
                        <TabPanel header={translateCommons('Videos')}>
                            <div className="w-full" style={{minHeight: '40vh'}}>
                                <p>
                                    <strong>
                                        {' '}
                                        {translateCommons(
                                            'Please select the video to learn more about TaVIE',
                                        )}
                                    </strong>
                                </p>
                                <div className="grid col-12 m-0 p-0">
                                    {videoDataList &&
                                        videoDataList?.length > 0 &&
                                        videoDataList.map((item, idx) => (
                                            <div
                                                key={item.key}
                                                className="flex flex-column justify-content-start align-items-center col-12 sm:col-6 md:col-6 lg:col-6">
                                                <div className="col-12 surface-100 border-round-lg h-full m-0 p-0">
                                                    <Skeleton
                                                        id={idx}
                                                        className="w-full h-max m-0 p-0">
                                                        <iframe
                                                            onLoadCapture={() => {
                                                                document
                                                                    .getElementById(
                                                                        idx,
                                                                    )
                                                                    .classList.add(
                                                                        'p-skeleton-none',
                                                                    )
                                                            }}
                                                            id="video-container"
                                                            className="w-full"
                                                            style={{
                                                                aspectRatio:
                                                                    '6/5',
                                                                border: 'none',
                                                            }}
                                                            src={item.video}
                                                            title="YouTube video player"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        />
                                                    </Skeleton>
                                                    <div className="col-12 p-4">
                                                        <p className="text-800 font-semibold">
                                                            {translateCommons(
                                                                item.key,
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header={translateCommons('Document')}>
                            <div className="w-full" style={{minHeight: '40vh'}}>
                                <p>
                                    <strong>
                                        {translateCommons(
                                            'Please click on the button below to download the document',
                                        )}
                                    </strong>
                                </p>
                                <a
                                    href={UserGuide}
                                    download="TaVIE-User-Guide.pdf"
                                    target="_blank"
                                    rel="noreferrer">
                                    <Button
                                        className="p-button-primary col-12 w-full h-3rem"
                                        icon="pi pi-download"
                                        label={translateCommons(
                                            'Download Document',
                                        )}
                                    />
                                </a>
                                <img
                                    className="py-3"
                                    src={downloadImg}
                                    style={{width: '100%', height: 300}}
                                    alt=""
                                />
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </Dialog>
        </div>
    )
})

export default Tutorial
